// ResetPassword.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { confirmPasswordReset } from "firebase/auth";
import { auth } from "./firebase";
import "./ForgotPassword.css"; // same styling

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get("oobCode"); // firebase reset token

  const [newPassword, setNewPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!oobCode) {
      setError("Invalid or expired reset link.");
    }
  }, [oobCode]);

  const handlePasswordReset = async () => {
    if (!newPassword || !confirmPass) {
      return setError("Enter all fields.");
    }
    if (newPassword !== confirmPass) {
      return setError("Passwords do not match.");
    }

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      alert("Password reset successful! Login now.");
      navigate("/signin");
    } catch (err) {
      console.error(err);
      setError("Reset link expired or already used.");
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <h1>Reset Password</h1>

        {error && <p style={{ color: "red", marginBottom: "10px" }}>{error}</p>}

        <input
          type="password"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder="Confirm new password"
          value={confirmPass}
          onChange={(e) => setConfirmPass(e.target.value)}
        />

        <button onClick={handlePasswordReset}>Reset Password</button>

        <p onClick={() => navigate("/signin")} className="back-to-signin">
          Back to Sign In
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
